import React, { useState, useEffect } from 'react'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { Tooltip } from 'react-tooltip'
import { FaReply } from 'react-icons/fa'
import { IoInformationCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux'
import { messageListRes, messageListTodo } from '../../LMS_Redux/LMS_Slices/Messages/MessageList'
import MessageReply from './MessageReply'
import { ToastContainer } from 'react-toastify'
import MessageDetails from './MessageDetails'

export default function MessageList() {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const [replyModal, setReplyModal] = useState(false)
    const [msgDetailsModal, setMsgDetailsModal] = useState(false)
    const [replyData, setReplyData] = useState()
    const message = useSelector(state => state.messageList && state.messageList.data && state.messageList.data.data)
    // console.log(message, '-store')

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const mergedArray = message && message.askQuestionList && message.askQuestionList.map((item) => {
        const ask_by_user = message && message.usersData && message.usersData.find((obj) => obj.vemp_code === item.asked_by);
        const ans_by_user = message && message.usersData && message.usersData.find((obj) => obj.vemp_code === item.ans_by);
        return {
            ...item,
            ask_by_nc: ask_by_user ? `${ask_by_user.vemp_fname} - (${ask_by_user.vemp_company_code})` : null,
            ans_by_nc: ans_by_user ? `${ans_by_user.vemp_fname} - (${ans_by_user.vemp_company_code})` : null,
        };
    })
    // console.log(mergedArray)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'ASKED BY',
            field: 'ask_by_nc',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESCRIPTION',
            field: 'description',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REPLY',
            field: 'answer',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REPLY BY',
            field: 'ans_by_nc',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => msg_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Message Details!"
                        data-tooltip-place="bottom"
                    />

                    {role !== 'Learner' ?
                        <FaReply size={20} className='edit ms-3'
                            onClick={() => msg_reply(params)}
                            data-tooltip-id='edit'
                            data-tooltip-content="Reply!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const msg_details = (params) => {
        setMsgDetailsModal(true)
        setReplyData(params.data)
    }

    const msg_reply = (params) => {
        setReplyModal(true)
        setReplyData(params.data)
    }

    const message_res = () => {
        if (messageListRes && messageListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(messageListTodo()).then(() => message_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Messages Management / </span>
                    <span className='icon2'>Message List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    mergedArray && mergedArray.length ?
                        <DataTables
                            rowData={mergedArray}
                            columnDefs={columnDefs}
                        />
                        :
                        <div className='wrapper-admin'>
                            <div className='text-center'>
                                <h5>Message List Not Found</h5>
                            </div>
                        </div>
                }
            </div>

            <MessageReply replyModal={replyModal} setReplyModal={setReplyModal} replyData={replyData} setReplyData={setReplyData} bool={bool} setBool={setBool} />
            <MessageDetails msgDetailsModal={msgDetailsModal} setMsgDetailsModal={setMsgDetailsModal} replyData={replyData} setReplyData={setReplyData} />
            <ToastContainer />
        </>
    )
}
